export const api_route = 'https://codex.centralindia.cloudapp.azure.com';
//export const api_route = 'http://localhost:3000';
